<div class="body-container">
    <app-single-card class="app-card" [title]="'Autocadastro'" [description]="''">
        <div class="mensagem-esgotado">
            Acabaram as licenças disponíveis para este autocadastro
        </div>
    </app-single-card>
</div>
